<template>
  <div class="vip-home">
    <header class="header">
      <div class="search-box flex" @click="goSearch">
        <div class="car-type flex">
          <div class="car-type-box" :class="{'yellow-active' : searchForm.type === 2}" >黄牌</div>
          <div class="car-type-box" :class="{'blue-active' : searchForm.type === 1}" >蓝牌</div>
        </div>
        <div class="input-search flex" >
          <input :value="vno || ''" style="color: #000000" disabled placeholder="请输入货车车牌号" type="text">
        </div>
        <div class="operation flex" @click.stop="againSearch">
          <svg t="1569292261735" class="icon"
            viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="2070"
            xmlns:xlink="http://www.w3.org/1999/xlink" width="23" height="23">
            <path d="M939.44 848.87L752.66 662.09a373.38 373.38 0 1 0-55.39 57.75l185.6 185.6a8 8 0 0 0 11.32 0l45.25-45.25a8 8 0 0 0 0-11.32zM458 727a292 292 0 1 1 206.48-85.53A290.08 290.08 0 0 1 458 727z" p-id="2071" fill="#CCCCCC"></path>
          </svg>
        </div>
        <div class="remind flex" @click.stop="goArriveRemind">
          <img src="../../../assets/images/search/remind.png" alt="" srcset="">
        </div>
      </div>
    </header>
    <div id="map" ></div>
    <div class="left-menu" >
      <div class="vip-recharge" v-if="isAndroid" @click.stop="goVipRecharge">
        <img src="../../../assets/images/hisTrack/vip-icon.png" alt="" srcset="">
      </div>
      <div class="story-activity" v-if="story_activity.showBubble" @click.stop="goStoryActivity">
        <img src="../../../assets/images/activity/story-activity-icon.png">
      </div>
      <!-- <div class="download-app" @click.stop="goAppDownload">
        <div>下载</div>
        <div>APP</div>
      </div> -->
      <div class="forbid" v-show="vno && this.carData.lat" @click.stop="goForbid">
        <div>定位</div>
        <div>不准</div>
      </div>
    </div>
    <div class="convenient">
      <div class="convenient-top">
        <div class="android-system" v-if="isAndroid">
          <div class="ticket-box" >
            <div class="ticket"  @click="showticketDetail">
              <div class="title">票</div>
              <div class="number">{{ticketTotal || 0}}</div>
            </div>
            <div class="month-card" @click="goMonthCard">
              <div class="title">月卡</div>
              <div class="number">{{monthCardNum || 0}}</div>
            </div>
          </div>
          <div class="ticket-box recharge-box">
            <div class="recharge" @click="goRecharge">
              <img src="../../../assets/images/hisTrack/pay.png" alt="" srcset="">
              <div class="recharge-title">充值</div>
            </div>
            <div class="convenient-box welfare" @click="goJobList">
              <img src="../../../assets/images/hisTrack/welfare.png" alt="" srcset="">
              <div>福利</div>
              <div class="remind" v-if="!isAllHasAttendGold"></div>
            </div>
          </div>
        </div>
        <div class="ios-system" v-else>
          <div class="ticket-box convenient-box">
            <div class="ticket"  @click="showticketDetail">
              <div class="title">票</div>
              <div class="number">{{ticketTotal || 0}}</div>
            </div>
          </div>
          <div class="welfare convenient-box" @click="goJobList">
            <img src="../../../assets/images/hisTrack/welfare.png" alt="" srcset="">
            <div>福利</div>
          </div>
        </div>
        <div class="complaint" @click="goComplaint">
          <img src="../../../assets/images/hisTrack/complaint.png" alt="" srcset="">
        </div>
      </div>
      <!-- <div class="integral-entrance" v-if="showIntegralEntrance"  @click="gointegral">
        <img src="../../../assets/images/activity/integral-entrance.png" />
      </div> -->
    </div>
    <div class="pt-activity" v-if="canptGroup && !isIos" @click="goActivity">
      <img src="../../../assets/images/activity/ground-eleven-open.gif" alt="" srcset="">
    </div>
    <!-- 显示票数详情弹框 -->
    <votes-detail-dialog ref="VotesDetailDialog"></votes-detail-dialog>
    <off-line-reason-dialog ref="OffLineReasonDialog"></off-line-reason-dialog>
    <first-search-car-dialog @agree="agreeBtn" ref="FirstSearchCarDialog"></first-search-car-dialog>
    <shield-search-car-dialog ref="ShieldSearchCarDialog"></shield-search-car-dialog>
    <tip-dialog
        ref="TipDialog"
        :message="tipMessage"
        :btntext="tipBtnText"
        :title="tipTitle"
        @define="tipDialogDefineBtn"
    >
    </tip-dialog>
    <not-login ref="NotLogin"></not-login>
    <span-city-remind-dialog ref="SpanCityRemindDialog"></span-city-remind-dialog>
    <confirm-dialog
      :title='confirmTitle'
      @confirm='confirmDialogBtn'
      :message='confirmMessage'
      ref="ConfirmDialog">
    </confirm-dialog>
    <month-ticket-dialog
      @closeDialog="showEverydaySign"
      ref="MonthTicketDialog">
    </month-ticket-dialog>
    <no-authentication ref="NoAuthentication"></no-authentication>
    <eleven-dialog @close="closeElevenDialog" ref="ElevenDialog"></eleven-dialog>
    <calendar ref="Calendar" @confirm="getSelectDate"></calendar>
    <authorization-dialog
      ref="AuthorizationDialog"
      @success="isFirstSearchCarGet"
      :vno="vno"
      :vco="searchForm.type"
    >
    </authorization-dialog>
    <bubble-month-expire ref="BubbleMonthExpire"></bubble-month-expire>
    <identity-select-dialog ref="IdentitySelectDialog"></identity-select-dialog>
    <es-poster-dialog
      @down="downImgEsPosterDialog"
      @close="closeEsPosterDialog"
      ref="EsPosterDialog">
    </es-poster-dialog>">
    <no-access-network
      :type="no_access_type"
      ref="NoAccessNetwork"
    >
    </no-access-network>
    <welfare-activity-dialog
      ref="WelfareActivityDialog"
      @close="showMonthDialog"
    >
    </welfare-activity-dialog>
    <system-breakdown
      ref="SystemBreakdown"
    ></system-breakdown>
    <home-dialog ref="HomeDialog"></home-dialog>
  </div>
</template>

<script>

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import VotesDetailDialog from '../../../components/VotesDetailDialog/index' // 票数详情解释说明弹框
import OffLineReasonDialog from '../../../components/dialog/OffLineReasonDialog' // 车辆离线原因弹框
import FirstSearchCarDialog from '../../../components/dialog/FirstSearchCarDialog' // 第一次查车弹框
import ShieldSearchCarDialog from '../../../components/dialog/ShieldSearchCarDialog' // 黑名单或者未开启查车弹框
import SpanCityRemindDialog from '../../../components/dialog/SpanCityRemindDialog' // 跨市提醒弹窗
import NoAuthentication from '../../../components/dialog/NoAuthentication' // 未认证弹框
import ConfirmDialog from '../../../components/dialog/ConfirmDialog' // 确定弹框
import TipDialog from '../../../components/dialog/TipDialog' // 查询不到问题
import NotLogin from '../../../components/dialog/NotLogin'
import ElevenDialog from '../../../components/dialog//Activity/ElevenTipDialog'
import Calendar from '../../../components/calendar/index' // 日历组件
import IdentitySelectDialog from '@/components/dialog/Attestation/IdentitySelectDialog'
import MonthTicketDialog from '@/components/dialog/MonthTicketDialog' // 月票弹框
import AuthorizationDialog from '@/components/dialog/Authorization/index' // 授权验证弹框
import BubbleMonthExpire from '../../../components/Bubble/month-expire/index' // 票数到期气泡
import EsPosterDialog from '@/components/dialog/Poster/EsDialog' // 疫情海报弹框
import NoAccessNetwork from '@/components/dialog/NoAccessNetwork' // 车辆未入网弹框
import WelfareActivityDialog from '@/components/dialog/vip-home/WelfareActivity' // 召回活动弹框
import SystemBreakdown from '@/components/dialog/vip-home/SystemBreakdown' // 系统崩溃弹窗
import HomeDialog from '@/components/dialog/vip-home/HomeDialog'
import iconCar from '../../../assets/images/search/xhp_position_truck_image@2x.png'
import iconClose from '../../../assets/images/search/xhp_paopao_exit@2x.png'
import iconIndicate from '../../../assets/images/search/xhp_map_paopao_arrow@2x.png'
import iconSpanCity from '../../../assets/images/hisTrack/span-city.png'
import iconArrive from '../../../assets/images/hisTrack/arrive.png'
import iconSelectSpanCity from '../../../assets/images/hisTrack/select-span-city.png'
import iconSelectArrive from '../../../assets/images/hisTrack/select-arrive.png'
import iconDoubt from '../../../assets/images/hisTrack/doubt-arrive.png'
import iconTrajectory from '../../../assets/images/search/trajectory-icon.png'
import { gcj02tobd09, wgs84togcj02, direction } from '../../../utils/map'
import { searchCarvclNs, deleteSpanCityRemind, createClickStatistics } from '../../../api/searchCar'
import { isFirstSearchCar, addFirstQueryRecord } from '../../../api/utilApi'
import { getUseActivity, getUserAuthenticationStatus, getShowBubbleIntegral } from '../../../api/userInfoApi'
// import { canElevenGroup, exposureUv } from '../../../api/elevenActivity'
import { queryHisTrack } from '../../../api/hisTrackApi'
import { searchCarCode } from '../../../utils/searchCarUtil'
import { wxNavigateTo } from '../../../utils/WeChatUtil'
import { setItem, getItem, getUrlParam } from '../../../utils'
const listyle = 'color:#989898;padding-bottom:6px'
const remindstyle = `padding:2px 8px;align-items: center;
    justify-content: center;
    border-radius:12px;font-size: 12px;` // 提醒按钮的样式
const unCheckRemindStyle = 'border: 1px solid #5572fd;color: #5572fd;' // 未选中提醒按钮的样式
const CheckRemindStyle = 'background-color:#5572fd;color:#fff'
const remindImgStyle = 'width:16px;padding-right:4px'
const opts = {
  boxStyle:{
    opacity: '1',
    background: '#ffffff',
    width: '230px',
    height: '200px',
    marginBottom: '100px'
  },
  closeIconUrl: iconClose,
  closeIconMargin: '-10px',
}
export default {
  props: {},
  data () {
    return {
      searchForm: {
        type: 2, // 1为蓝牌 2为黄牌
        vclNo: '' // 车牌号
      },
      map: null, // 地图
      point: null, // 地图中心点
      carData: {}, // 查询的车的信息
      tipMessage: '', // 提示弹框的mes
      tipTitle: '', // 提示弹框的title
      tipBtnText: '确定', // 提示弹框的按钮文案
      isAllHasAttendGold: false, // 是否参加所有活动
      confirmTitle: '', // 确认弹框title
      confirmMessage: '', // 确认弹框message
      timerUserShop: null,
      isAuthentication: false, //是否认证
      canptGroup: false, // 是否可以参加pt活动
      hisTrackDate: null, // 要查询轨迹的日期
      showIntegralEntrance: true, // 是否显示积分抽奖入口页
      hasNeedIdentity: false, // 是否认证过身份
      no_access_type: 0, // 查车无结果的存在类型
      system_timer: null, // 系统奔溃定时器
    }
  },
  computed: {
    ...mapState({
      can_recall: 'can_recall',
      system_error_data: 'system_error_data',
      userInfo: 'userInfo',
      story_activity: 'story_activity'
    }),
    ...mapGetters({
      isVip: 'isVip',
      vno: 'hisTrack/vno',
      monthCardNum: 'monthCardNum',
      ticketTotal: 'ticketTotal',
      getQueryParam: 'hisTrack/getQueryParam',
      platform: 'platform',
    }),
    user_openid() {
      return this.userInfo.user_openid
    },
    userId() {
      return this.userInfo.user_content.userId
    }
  },
  created () {},
  mounted () {
    this.init()
  },
  watch: {},
  methods: {
    ...mapMutations(['REFRESH_USER_PLATFORM']),
    ...mapActions({
      getUserActivityStatus: 'getUserActivityStatus',
      getSystemErrorStatus: 'getSystemErrorStatus',
      getUserShopInfo: 'refresh_user_shop_info',
      getStoryActivity: 'getStoryActivity'
    }),
    /**
     *
     * 初始化
     *
    */
    async init () {
      if (!getItem('nextMonth')) {
        setItem('nextMonth', moment().format('YYYY-MM'))
      }
      await this.getUserActivityStatus()
      // const show_welfare_activity_dialog = moment().format('YYYY-MM-DD') !== getItem('welfareDate')
      //   && this.can_recall && this.isAndroid // 是否显示召回活动弹框
      // if (show_welfare_activity_dialog) {
      //   this.showRefPopupDialog('WelfareActivityDialog')
      // } else {
      // } 下线8折活动
      this.$refs.HomeDialog.init()
      // this.showMonthDialog()
      // this.showEsPosterDialog() 下线疫情海报弹窗
      this.createMap()
      await this.getUserCanGroup()
      await this.userIsAllActivity()
      await this.setUserAuthentication()
      await this.canShowBubbleIntegral()
      await this.getStoryActivity()
      // 设置定时器更新用户票数
      clearInterval(this.timerUserShop)
      this.timerUserShop = setInterval(() => {
        this.getUserShopInfo()
        this.setUserAuthentication()
      }, 3000)
    },

    /**
     *
     *
     *
     * 创建地图
    */
    createMap () {
      let map = new BMap.Map('map') // 创建地图实例
      this.point = new BMap.Point(116.4, 39.91) // 创建点坐标
      map.centerAndZoom(this.point, 12)
      map.addControl(new BMap.MapTypeControl({
        mapTypes: [BMAP_NORMAL_MAP,BMAP_SATELLITE_MAP],
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        offset: new BMap.Size(20, 40)
      }))
      this.map = map
      this.setvclNo()
    },
    /**
     *
     *
     *
     * 去搜索页
     */
    goSearch () {
      const today = moment().format('YYYY-MM-DD')
      console.log(today, getItem('hasNeedIdentityDate'), '身份选择日期')
      if (this.hasNeedIdentity && getItem('hasNeedIdentityDate') !== today) {
        setItem('hasNeedIdentityDate', today)
        this.$refs.IdentitySelectDialog.showPopup()
        return
      }
      // if (this.isAuthentication) {
      //   this.$refs.NoAuthentication.showPopup()
      //   return
      // }
      if (this.isWechart) {
        wx.miniProgram.navigateTo({
          url: `/pages/search/search?inputValue=${this.vno}&inputType=${this.searchForm.type}`
        });
      }
    },

    /**
     *
     *
     *
     * 重新搜索车辆
    */
    againSearch () {
      if (this.vno) {
        this.map.clearOverlays()
        this.isFirstSearchCarGet()
      } else {
        this.goSearch()
      }
    },

    /**
     * 首次查的车牌号确认事件
    */
    agreeBtn () {
      this.getCarLoction()
    },

    /**
     *
     *
     * 如果用户是第一次查车，增加历史记录
     * @param vnos 车牌号
    */
    async addSearchCarHistory (vnos) {
      await addFirstQueryRecord({vnos})
    },

    /**
     *
     *
     * 判断是否是第一次查询车牌号
     * @param is_trajectory 是不是轨迹查询
    */
    async isFirstSearchCarGet (is_trajectory) {
      const param = [{ vclNs: this.vno, color: this.searchForm.type }]
      const response = await isFirstSearchCar(param)
      if (response && response.isSuccess) {
        const { data, otherData} = response
        if (otherData.isNewUserAuth) {
          // 判断用户是不是新用户
          this.$refs.AuthorizationDialog.showPopup(otherData.remainingNumber)
        } else {
          if (!is_trajectory) {
            // 不是轨迹去查询车的位置
            if (data.length) {
              this.$refs.FirstSearchCarDialog.showPopup()
              this.addSearchCarHistory(this.vno)
            } else {
              this.getCarLoction()
            }
          } else {
            this.searchHisTrack()
          }
        }
      }
    },

    /**
     *
     *
     *
     * 显示票数详情
    */
    showticketDetail () {
      this.$refs.VotesDetailDialog.showPopup()
    },

    /**
     *
     *
     *
     * 设置车牌号
    */
    setvclNo () {
      // 用户要搜索的车牌号
      if (getUrlParam('vno')) {
        const vno = decodeURIComponent(getUrlParam('vno'))
        this.searchForm.type = Number(decodeURIComponent(getUrlParam('type'))) || 1
        if (vno) {
          this.$store.dispatch('hisTrack/setQueryParam', { vno })
          this.isFirstSearchCarGet()
        }
      }
    },

    /**
     *
     *
     *
     * 获取卡车位置
    */
    async getCarLoction () {
      const param = [{
        vclNs: this.vno,
        color: this.searchForm.type
      }]
      const response = await searchCarvclNs(param)
      if (response) {
        const { code, data } = response
        if (code === 10000) {
          const { reusltList } = data
          if (reusltList && reusltList.length) {
            this.carData = reusltList[0]
            const { lat, lon } = this.carData
            const lng = lon
            const gcj02 = wgs84togcj02( Number(lng) / 600000, Number(lat) / 600000)
            const maplng = gcj02tobd09(gcj02.lng, gcj02.lat).lng
            const maplat = gcj02tobd09(gcj02.lng, gcj02.lat).lat
            this.point = new BMap.Point(maplat, maplng + 0.002)
            const point = new BMap.Point(maplat, maplng)
            const currentDate = moment().format('YYYY-MM-DD HH:mm:ss') // 当前系统时间
            const carupdateDate = moment(Number(this.carData.utc)).format('YYYY-MM-DD HH:mm:ss') // 车辆最后更新时间
            const timeDifference = moment(currentDate).diff(moment(carupdateDate), 'minute')
            this.carData.carline = timeDifference > 60 // 车辆状态是否在线 大于60离线
            this.carData.carupdateDate = carupdateDate
            this.carData.direction = direction(Number(this.carData.drc)) // 设置车辆方向
            this.setCarLoction(point)
          }
        } else if (code === 70001) {
          this.$refs.ShieldSearchCarDialog.showPopup()
        }
        else if (code === 70422) {
          // 系统奔溃了
          await this.getSystemErrorStatus()
          if (this.system_error_data.show_dialog) {
            // 判断如果系统奔溃，关闭弹框，继续查车
            this.system_timer = setInterval(() => {
              this.getSystemErrorStatus()
              if (!this.system_error_data.show_dialog) {
                clearInterval(this.system_timer)
                this.system_timer = null
              }
            }, 10000)
          }
        }
        else {
          this.tipTitle = code === 70003 ? '提示' : '未查询到车辆信息'
          if (code === 70003 && this.isWechart) {
            // code 是70003并且是微信表示票数不足 苹果提示去app充值使用
            this.tipMessage = this.isAndroid ? '您的剩余票数不足，请前往会员商城充值' :  '您的票数为零，请至APP充值继续使用'
            this.tipBtnText = this.isAndroid ? '确定' : '立即下载APP'
          } else {
            if (code === 40030) {
              const { truckExist } = response.otherData
              if (truckExist >= 0) {
                this.no_access_type = truckExist
                this.$refs.NoAccessNetwork.showPopup()
                return
              }
            }
            // 车辆无数据
            this.tipMessage = searchCarCode(code)
          }
          this.$refs.TipDialog.showPopup()
        }
      }
    },
    /**
     *
     *
     * @param point 位置信息
     * 设置卡车位置
    */
    setCarLoction (point) {
      const deviceSize = new BMap.Size(20, 67)
      const carIcon = new BMap.Icon(iconCar , deviceSize, {
        imageSize: deviceSize
      })
      const {
        carline,
        carupdateDate,
        spd,
        direction,
        adr,
        drc,
        subscribe,
        hasSubscribe
      } = this.carData
      const markerCar = new BMap.Marker(point, {icon: carIcon, rotation: drc})
      this.map.addOverlay(markerCar)
      const vnoBackColor = this.searchForm.type === 2 ? '#FFCC23' : '#5572FD'
      const carlineTitle = carline ? '离线' : '在线'
      const timediv = carline ? `<span style='color:#FC3435'>${carupdateDate}</span>` : `<span style='color:#1B1B20'>${carupdateDate}</span>`
      const statediv = `
      <div class='flex' style='justify-content: space-between;width: 100%'>
          <div style='background-color: ${vnoBackColor};width:90px;
            font-size:14px;border-radius: 4px;font-weight: 700;
            height:20px;line-height:20px;text-align:center;border:2px solid #282828;color:#282828'  
            id='vnoinfo'>
            ${this.carData.vno}
          </div>
          <div id='trajectory' class='flex' style='
            width: 60px;
            height: 20px;
            align-items: center;
            font-size: 12px;
            color: #FFFFFF;
            justify-content: center;
            background-color: #5572FD;
            border-radius:25px;
          '>
            <img style='width: 12px;padding-right: 6px' src='${iconTrajectory}' />
            轨迹
          </div>
      </div>`
      const ArriveRemindStyle = hasSubscribe ? CheckRemindStyle : unCheckRemindStyle
      const SpanCityStyle = subscribe ? CheckRemindStyle : unCheckRemindStyle
      const SpanCityImg = subscribe ? iconSelectSpanCity : iconSpanCity
      const ArriveImg = hasSubscribe ? iconSelectArrive : iconArrive
      const carContent = `<div style='padding: 10px 18px;
        background-color: #ffffff;
        '>
          <div style='display:flex;align-items: center;'>${statediv}</div>  
          <ul style='padding-top:10px;font-size: 12px'>
            <li style='${listyle}' class='flex'>
              <div>车辆状态： <span style='color:#1B1B20'>${carlineTitle}</span></div>
              ${carline ? '<div id=\'seeReason\' style=\'color:#5572FD;text-decoration:underline;padding-left:20px\'>查看原因</div>' : ''}
            </li>
            <li style='${listyle}'>
              最后更新： ${timediv}
            </li>
            <li style='${listyle}'>
              当前车速： <span style='color:#1B1B20'>${spd}km/h</span>
            </li>
            <li style='${listyle}'>
              行驶方向： <span style='color:#1B1B20'>${direction}</span>
            </li>
            <li style='${listyle}'>
              位置方向：<span style='color:#1B1B20'>${adr}</span>
            </li>
          </ul>
          <div class='flex' id='arrive-remind' style='justify-content: space-between'>
            <div class='flex' style='${remindstyle}${ArriveRemindStyle}'>
              <img style='${remindImgStyle}' src='${ArriveImg}'></img>到达提醒
            </div>
            <div class='flex' id='span-city' style='${remindstyle}${SpanCityStyle}'>
              <img style='${remindImgStyle}' src='${SpanCityImg}'></img>跨市提醒
            </div>
          </div>
          <div class='flex'  style='justify-content: flex-end;margin-top:10px;'>
            <div class='flex' id='doubt-span-city' style='font-size: 12px;color:#ccc'>
              <img style='width:15px;height:15px;padding-right:2px' src='${iconDoubt}'></img>
              跨市提醒
            </div>
          </div>
        </div>
        <div style='text-align: center'><img style='width:50px' src='${iconIndicate}' /></div>
        `
      const carInfo = new BMapLib.InfoBox(this.map, carContent ,opts)
      carInfo.open(markerCar)
      markerCar.addEventListener('click', () => {
        carInfo.open(markerCar)
      })
      carInfo.addEventListener('open', () => {
        const closeImg = document.getElementsByClassName('infoBox')[0].getElementsByTagName('img')[0]
        closeImg.style.width = '20px'
        closeImg.addEventListener('touchend', () => {
          carInfo.close()
        })
        this.setLabelEvent()
      })
      this.map.centerAndZoom(this.point, 17)
    },

    /**
     *
     *
     *
     * 订阅跨市提醒
    */
    addSpanCityRemind () {
      const {
        vno,
        vco,
        city
      } = this.carData
      if(this.isWechart) {
        // 微信跳订阅页面
        wxNavigateTo(`/pages/spanCity/index?vno=${vno}&vco=${vco}&cityName=${city}`)
      }
    },

    /**
     *
     *
     *
     * 设置提醒按钮的html
    */
    setArriveRemindHtml () {
      const { hasSubscribe, subscribe} = this.carData
        const arriveRemind = document.getElementById('arrive-remind')
        const ArriveRemindStyle = hasSubscribe ? CheckRemindStyle : unCheckRemindStyle
        const ArriveImg = hasSubscribe ? iconSelectArrive : iconArrive
        const SpanCityImg = subscribe ? iconSelectSpanCity : iconSpanCity
        const SpanCityStyle = subscribe ? CheckRemindStyle : unCheckRemindStyle
        arriveRemind.innerHTML = `
          <div class='flex' style='${remindstyle}${ArriveRemindStyle}'>
              <img style='${remindImgStyle}' src='${ArriveImg}'></img>到达提醒
            </div>
            <div class='flex' id='span-city' style='${remindstyle}${SpanCityStyle}'>
              <img style='${remindImgStyle}' src='${SpanCityImg}'></img>跨市提醒
          </div>
        `
    },

    /**
     *
     *
     *
     * 设置百度地图气泡里面的事件
    */
    setLabelEvent () {
       const seeReason = document.getElementById('seeReason')
        if (seeReason) {
          seeReason.addEventListener('touchend', () => {
            this.$refs.OffLineReasonDialog.showPopup()
          })
        }
        const doubtSpanCity = document.getElementById('doubt-span-city') // 跨市提醒疑问
        if (doubtSpanCity) {
          doubtSpanCity.addEventListener('touchend', () => {
            this.$refs.SpanCityRemindDialog.showPopup()
          })
        }
        const SpanCity = document.getElementById('span-city') // 跨市提醒点击事件
        if (SpanCity) {
          SpanCity.addEventListener('touchend', (e) => {
            e.stopPropagation()
            if (!this.carData.subscribe) {
              this.addSpanCityRemind()
            } else {
              this.cancleSpanCityRemind()
            }
          })
        }
        const ArriveRemind = document.getElementById('arrive-remind') // 到达提醒点击事件
        if (ArriveRemind) {
          ArriveRemind.addEventListener('touchend', (e) => {
            e.stopPropagation()
            if (this.isWechart) {
              wxNavigateTo(`../job/edit?vno=${this.vno}&type=${this.searchForm.type}`)
            }
          })
        }

        const trajectory = document.getElementById('trajectory') // 设置轨迹点击事件
        if (trajectory) {
          trajectory.addEventListener('touchend', e => {
            e.stopPropagation()
            if (this.ticketTotal === 0) {
              let message = ''
              let btn_text = '确定'
              if (this.isWechart) {
                message = this.isAndroid ? '您的剩余票数不足，请前往会员商城充值' : '票数不足，请前往APP使用'
                btn_text = this.isIos ? '立即下载APP' : '确定'
              } else {
                message = this.isAndroid ? '您的剩余票数不足，请前往会员商城充值' : '请前往APP使用'
              }
              this.showTipDialog({
                title: '提示',
                message,
                btn_text
              })
              return
            }
            if (this.isWechart && !this.isVip && this.isIos) {
              this.showTipDialog({
                title: '提示',
                message: '请至货车定位app使用',
                btn_text: '确定'
              })
              return
            }
            this.$refs.Calendar.showPopup()
          })
        }
    },

    /**
     *
     *
     *
     * 去提醒任务页面
    */
    goArriveRemind () {
      if (this.isWechart) {
        wxNavigateTo('../job/list')
      }
    },

    /**
     *
     *
     *
     * 去福利中心
    */
    goJobList () {
      if (this.isWechart) {
        wxNavigateTo(`../activity/center?userId=${this.userId}`)
      }
    },

    /**
     *
     *
     *
     * 去投诉页
    */
    goComplaint () {
      if (this.isWechart) {
        wxNavigateTo('../custom/custom')
      }
    },

    /**
     *
     *
     *
     * 去vip充值页
    */
    goVipRecharge () {
      if (this.isWechart) {
        wxNavigateTo(`../shop/shop?type=1&userId=${this.userId}&openId=${this.user_openid}`)
      }
    },

    /**
     *
     *
     *
     * 去月卡页面
    */
    goMonthCard () {
      if (this.isWechart) {
        wxNavigateTo(`../shop/shop?type=2&userId=${this.userId}&openId=${this.user_openid}&cardNum=${this.monthCardNum}`)
      }
    },

    /**
     *
     *
     *
     * 去充值页
    */
    goRecharge () {
      if (this.isWechart) {
        wxNavigateTo(`../shop/shop?type=0&userId=${this.userId}&openId=${this.user_openid}`)
      }
    },

    /**
     *
     *
     *
     * 去定位不准页面
    */
    goForbid () {
      const { locationRecordId } = this.carData
      if (this.isWechart) {
        wxNavigateTo(`/pages/index/uploadLocation/index?vno=${this.vno}&type=${this.searchForm.type}&locationRecordId=${locationRecordId}`)
      }
    },

    /**
     *
     *
     *
     * 取消跨市提醒
    */
    async cancleSpanCityRemind () {
      const { subscribe } = this.carData
      const response = await deleteSpanCityRemind(subscribe)
      if (response) {
        this.showTipDialog({
            title: '提示',
            message: '取消提醒成功',
            btn_text: '确定'
        })
        this.carData.subscribe = null
        this.setArriveRemindHtml()
        const SpanCity = document.getElementById('span-city') // 跨市提醒点击事件
        if (SpanCity) {
          SpanCity.addEventListener('touchend', (e) => {
            e.stopPropagation()
            console.log(e, '到达')
            if (!this.carData.subscribe) {
              this.addSpanCityRemind()
            } else {
              this.cancleSpanCityRemind()
            }
          })
        }
        // this.setLabelEvent()
        // this.againSearch()
      }
    },

    /**
     *
     *
     *
     * 判断用户是否已经参加完所有活动
    */
    async  userIsAllActivity () {
      const response = await getUseActivity ()
      if (response.isSuccess) {
        this.isAllHasAttendGold = response.data.hasAttendAllActivity
      }
    },

    /**
     *
     *
     *
     * 显示每日弹框
    */
    showEverydaySign () {
      const date = moment().format('YYYY-MM-DD')
      const SignDate = getItem('SignDate') || null
      this.confirmTitle = '每日签到'
      this.confirmMessage = '每日签到领积分，可以免费兑换票哟！'
      if (SignDate) {
        if (SignDate < date) {
          this.$refs.ConfirmDialog.showPopup()
          setItem('SignDate', date)
        }
      } else {
         this.$refs.ConfirmDialog.showPopup()
         setItem('SignDate', date)
      }
    },

    /**
     *
     *
     *
     * 显示月弹框
    */
    showMonthDialog () {
      const date = moment().format('YYYY-MM')
      const nextMonth = getItem('nextMonth') || null
      const { hasFreeUpdate } = this.$store.state.userInfo || null
      if (date === nextMonth && hasFreeUpdate) {
        this.$refs.MonthTicketDialog.showPopup()
      } else {
        this.showEverydaySign()
      }
    },

    /**
     *
     *
     *
     * 确认弹框确认事件
    */
    confirmDialogBtn () {
      if (this.confirmTitle === '每日签到' && this.isWechart) {
          wxNavigateTo('../activity/sign/sign')
      }
    },

    /**
     *
     *
     *
     * 设置用户的认证状态
    */
    async setUserAuthentication () {
      const response = await getUserAuthenticationStatus ()
      if (response && response.isSuccess) {
        const { hasNeedAuth, hasNeedIdentity } = response.data
        const { payTicketExpiredNotifyTime } = response.data.dictionaries
        if (getItem('remindDate') !== moment().format('YYYY-MM-DD')) {
          this.$refs.BubbleMonthExpire.showBubble(payTicketExpiredNotifyTime)
        }
        this.hasNeedIdentity = hasNeedIdentity
        this.isAuthentication = hasNeedAuth
      } else {
        clearInterval(this.timerUserShop)
      }
    },

    /**
     *
     *
     * 获取选择的日期
     * @param date 子组件返回的日期
    */
    getSelectDate (date) {
      this.hisTrackDate = date
      this.isFirstSearchCarGet(true)
    },

    /**
     *
     *
     *
     * 查询轨迹历史记录
    */
    async searchHisTrack () {
      const param = {
        vclN: this.vno,
        qryBtm: `${this.hisTrackDate} 00:00:00`,
        qryEtm: `${this.hisTrackDate} 23:59:59`
      }
      await createClickStatistics({type: 75, value: 1})
      const response = await queryHisTrack (param)
      const { code, data } = response
      if (response.success) {
        sessionStorage.setItem('trajectory' , JSON.stringify(data))
        this.getUserShopInfo()
        this.$router.push({ path: '/hisTrack/map', query: { vno: this.vno } })
        // 查询成功刷新用户商城信息
      } else if (code === 70001) {
        this.$refs.ShieldSearchCarDialog.showPopup()
      } else if(code === 70422) {
        // 系统奔溃了
        await this.getSystemErrorStatus()
          if (this.system_error_data.show_dialog) {
            // 判断如果系统奔溃，关闭弹框，继续查车
            this.system_timer = setInterval(() => {
              this.getSystemErrorStatus()
              if (!this.system_error_data.show_dialog) {
                clearInterval(this.system_timer)
                this.system_timer = null
              }
            }, 10000)
          }
      } else {
        let message = ''
        switch (code) {
          case 60010: message = '参数错误'; break;
          case 70003: message = '票数不足'; break;
          case 40030: message = '无查询结果,请换个时间段查询'; break;
          default: message= `系统繁忙请稍后再试${code}`
        }
        this.showTipDialog({
            title: '提示',
            message,
            btn_text: '确定'
        })
      }
    },

    /**
     *
     *
     * 获取用户是否可以参加活动
    */
    async canShowBubbleIntegral () {
      const response = await getShowBubbleIntegral()
      if (response && response.isSuccess) {
        this.showIntegralEntrance = response.data
      }
    },
    /**
     *
     *
     * 去积分转盘活动页面
    */
    gointegral () {
      if (this.isWechart) {
        wxNavigateTo('/pages/activity/turntable/index')
      }
    },
    /**
     *
     *
     * 去app下载页
    */
    goAppDownload () {
      if (this.isWechart) {
        wxNavigateTo('/pages/user/app/appDownload')
      }
    },
    /**
     *
     *
     * 显示疫情海报弹框
    */
    showEsPosterDialog () {
      const date = moment().format('YYYY-MM-DD')
      if(getItem('esPosterDate') !== date) {
        setItem('esPosterDate', date)
        this.$refs.EsPosterDialog.showPopup()
      } else {
        this.showMonthDialog()
      }
    },
    /**
     *
     * 去微信双十一活动页
    */
    // goActivity () {
    //   this.setCensusUv(66)
    //   if (this.isWechart) {
    //     wxNavigateTo('../activity/Eleven/home/index')
    //   }
    // },
    /**
     *
     *
     * 获取用户是否弹活动弹框
    */
    // async getUserCanGroup () {
    //   const response = await canElevenGroup()
    //   if (response.code === 10000) {
    //     const { data } = response
    //     this.canptGroup = data
    //   }
    // },

    /**
     *
     * 关闭活动弹框
     *
    */
    closeElevenDialog () {
      this.showEverydaySign()
    },
    /**
     *
     *
     * 关闭疫情海报事件
    */
    closeEsPosterDialog () {
      this.showMonthDialog()
    },
    /**
     *
     *
     * 下载疫情海报事件
    */
    downImgEsPosterDialog () {
      this.showMonthDialog()
    },
    /**
     *
     * @param type 统计type
     * 首页统计uv
    */
    // async setCensusUv (type) {
    //   await exposureUv(type)
    // },
    /**
     *
     * @param params title message btn_text
     * 显示tip提示弹框
    */
    showTipDialog (params) {
        const { title, message, btn_text } = params
        this.tipTitle = title || '提示'
        this.tipMessage = message || ''
        this.tipBtnText = btn_text || '确定'
        this.$refs.TipDialog.showPopup()
    },
    /**
     *
     *
     * tip弹框确定按钮点击事件
    */
    tipDialogDefineBtn () {
      if (this.isWechart && this.isIos && this.tipBtnText === '立即下载APP') {
       // 如果是ios微信并且按钮文案是下载APP
        wxNavigateTo('/pages/user/app/appDownload')
      }
    },
    /**
     *
     * @param ref 要显示的那个弹框
     * 显示弹框
    */
    showRefPopupDialog (ref) {
      this.$refs[ref].showPopup()
    },
    /**
     * 去故事活动页面
    */
    goStoryActivity () {
      if (this.isWechart) wxNavigateTo('/pages/activity/story/index')
    },
  },
  beforeDestroy () {
    clearInterval(this.timerUserShop)
  },
  components: {
    VotesDetailDialog,
    OffLineReasonDialog,
    FirstSearchCarDialog,
    ShieldSearchCarDialog,
    NotLogin,
    TipDialog,
    SpanCityRemindDialog,
    ConfirmDialog,
    MonthTicketDialog,
    NoAuthentication,
    ElevenDialog,
    Calendar,
    AuthorizationDialog,
    BubbleMonthExpire,
    IdentitySelectDialog,
    EsPosterDialog,
    NoAccessNetwork,
    WelfareActivityDialog,
    SystemBreakdown,
    HomeDialog
  }
};
</script>

<style scoped lang="scss">
@import '../../../assets/css/vip-home.scss'
</style>
